import { useLang } from "@/i18n/LanguageContext";
import { Star } from "lucide-react";

const Trust = () => {
  const { t } = useLang();
  const partners = t("trust.partners");
  // duplicate for marquee loop
  const loop = [...partners, ...partners];

  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-[#1f1f1f] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("trust.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95] mb-6">
              {t("trust.heading")}
            </h2>
            <p className="text-base md:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              {t("trust.lead")}
            </p>
          </div>

          <div className="lg:col-span-5">
            <a
              href="https://www.google.com/maps/place/MF+Dobra+Lakiernia+Proszkowa"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-rating-badge"
              className="block border border-[#27272a] p-6 hover:border-[#dc2626] transition-colors"
            >
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#71717a] mb-3">
                Google Reviews
              </p>
              <div className="flex items-end gap-4">
                <span className="font-display font-black text-5xl md:text-6xl text-white">
                  4,8
                </span>
                <div className="pb-2">
                  <div className="flex gap-0.5 mb-1">
                    {[1, 2, 3, 4, 5].map((s) => (
                      <Star
                        key={s}
                        className="w-4 h-4 fill-[#dc2626] text-[#dc2626]"
                      />
                    ))}
                  </div>
                  <p className="font-mono text-[11px] tracking-wider uppercase text-[#a1a1aa]">
                    32 opinii / reviews
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative border-y border-[#1f1f1f] py-8 md:py-10 overflow-hidden">
        <div className="marquee flex gap-12 md:gap-20 whitespace-nowrap will-change-transform">
          {loop.map((p, i) => (
            <span
              key={i}
              data-testid={i < partners.length ? `partner-${i}` : undefined}
              className="font-display font-black uppercase tracking-tight text-2xl md:text-4xl text-[#52525b] hover:text-[#dc2626] transition-colors"
            >
              {p} <span className="text-[#1f1f1f] mx-4">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
